import RpcClass from "../../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

import ObservableEntity from "../../../../../server/com/silkplm/engine/entities/ObservableEntity.js";
let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.model.sticky.StickyNote';

import LocalDate from "../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../server/LocalTime.js";



class StickyNote extends ObservableEntity {

    /**
     *  @class StickyNote
     *  @alias module:src/server/com/silkplm/model/sticky/StickyNote.StickyNote
     *  
     * */
    constructor(){
        super();

        /** @type {string}  */
        this.body = null;
        /** @type {string}  */
        this.businessEntityClass = null;
        /** @type {number}  */
        this.businessEntityId = null;
        /** @type {boolean}  */
        this.businessEntityIsDeleted = null;
        /** @type {LocalDateTime}  */
        this.date = null;
        /** @type {string}  */
        this.entityLabel = null;
        /** @type {string}  */
        this.formLabel = null;
        /** @type {string}  */
        this.id = null;
        /** @type {boolean}  */
        this.isCollapsed = null;
        /** @type {boolean}  */
        this.isPinned = null;
        /** @type {number}  */
        this.leftOffset = null;
        /** @type {module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata}  */
        this.recordMetadata = null;
        /** @type {number}  */
        this.topOffset = null;
        /** @type {module:src/server/com/silkplm/organization/StickyNoteType.StickyNoteType}  */
        this.type = null;
        /** @type {string}  */
        this.userId = null;

    }





    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/sticky/StickyNote.StickyNote}
     */
    withBody(val){
        this.body = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/sticky/StickyNote.StickyNote}
     */
    withBusinessEntityClass(val){
        this.businessEntityClass = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/sticky/StickyNote.StickyNote}
     */
    withBusinessEntityId(val){
        this.businessEntityId = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/sticky/StickyNote.StickyNote}
     */
    withBusinessEntityIsDeleted(val){
        this.businessEntityIsDeleted = val;
        return this;
    };


    /**
     * @param val {LocalDateTime}
     * @returns {module:src/server/com/silkplm/model/sticky/StickyNote.StickyNote}
     */
    withDate(val){
        let rawValue = val;
        let v = val;
        v = new LocalDateTime(); v.value = rawValue;
        this.date = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/sticky/StickyNote.StickyNote}
     */
    withEntityLabel(val){
        this.entityLabel = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/sticky/StickyNote.StickyNote}
     */
    withFormLabel(val){
        this.formLabel = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/sticky/StickyNote.StickyNote}
     */
    withId(val){
        this.id = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/sticky/StickyNote.StickyNote}
     */
    withIsCollapsed(val){
        this.isCollapsed = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/sticky/StickyNote.StickyNote}
     */
    withIsPinned(val){
        this.isPinned = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/sticky/StickyNote.StickyNote}
     */
    withLeftOffset(val){
        this.leftOffset = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata}
     * @returns {module:src/server/com/silkplm/model/sticky/StickyNote.StickyNote}
     */
    withRecordMetadata(val){
        this.recordMetadata = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/sticky/StickyNote.StickyNote}
     */
    withTopOffset(val){
        this.topOffset = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/organization/StickyNoteType.StickyNoteType}
     * @returns {module:src/server/com/silkplm/model/sticky/StickyNote.StickyNote}
     */
    withType(val){
        this.type = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/sticky/StickyNote.StickyNote}
     */
    withUserId(val){
        this.userId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getUserIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.users.ApplicationUser', 'userId', allowRemote); //  false 
    }

    /** @returns {String} */
        getUserIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.users.ApplicationUser', 'userId'); //  false 
    }

        /** @returns {Promise<ApplicationUser>} */
    getUserIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.users.ApplicationUser', 'userId', allowRemote); //  false 
    }




    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};
metadata['body'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['businessEntityClass'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['businessEntityId'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['businessEntityIsDeleted'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['date'] = {'remoteType' : 'java.time.LocalDateTime', 'jsType' : 'LocalDateTime', 'mapped' : 'true'};
metadata['entityLabel'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['formLabel'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['id'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['isCollapsed'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['isPinned'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['leftOffset'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['recordMetadata'] = {'remoteType' : 'module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata', 'jsType' : 'module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata', 'mapped' : 'false'};
metadata['topOffset'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['type'] = {'remoteType' : 'module:src/server/com/silkplm/organization/StickyNoteType.StickyNoteType', 'jsType' : 'module:src/server/com/silkplm/organization/StickyNoteType.StickyNoteType', 'mapped' : 'false'};
metadata['userId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};

metadata.__type__ = 'com.silkplm.model.sticky.StickyNote';
metadata.__type_short__ = 'StickyNote';
StickyNote.prototype.__metadata__ = metadata;

StickyNote.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/model/sticky/StickyNote */
export default StickyNote

export { StickyNote }
